import { useMemo } from "react";
import { ActThemeProvider } from "@act-group/act-ui-library";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import { getActBrandTheme } from "../theme/actBrandTheme";
import { ThemeModeProvider, useThemeMode } from "../theme/ThemeModeContext";
import AppProviders from "./AppProviders";
import AppRouter from "./AppRouter";

function ThemedApp() {
  const { mode } = useThemeMode();
  const theme = useMemo(() => getActBrandTheme(mode), [mode]);

  return (
    <ActThemeProvider theme={theme}>
      <ErrorBoundary>
        <AppProviders>
          <AppRouter />
        </AppProviders>
      </ErrorBoundary>
    </ActThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  );
}

export default App;
